import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

import urls from '../../../../networkRequests/apiClient/endpoints'
import errorHandler from '../../../../shared/functions/ErrorHandler/errorHandler.functions'
import { ApiErrorResponse } from '../../../../shared/types/api.types'
import { getSupportedLoyaltyProgramsApi } from './getSupportedLoyaltyPrograms.api'
import getSupportedLoyaltyProgramsInitialState from './getSupportedLoyaltyPrograms.initialState'
import {
  GetSupportedLoyaltyProgramsErrorResponse,
  GetSupportedLoyaltyProgramsRequestPayload
} from './getSupportedLoyaltyPrograms.types'

export const getSupportedLoyaltyPrograms = createAsyncThunk(
  urls.supportedLoyaltyPrograms.getSupportedLoyaltyPrograms,
  async (payload: GetSupportedLoyaltyProgramsRequestPayload, { rejectWithValue }) => {
    const { onSuccess } = payload

    try {
      const response = await getSupportedLoyaltyProgramsApi()
      onSuccess && onSuccess(response.data)

      return response
    } catch (error) {
      errorHandler.handleApiError(error as ApiErrorResponse)

      return rejectWithValue(error)
    }
  }
)

const getSupportedLoyaltyProgramsSlice = createSlice({
  name: urls.supportedLoyaltyPrograms.getSupportedLoyaltyPrograms,
  initialState: getSupportedLoyaltyProgramsInitialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getSupportedLoyaltyPrograms.pending, (state) => {
        state.loading = true
        state.error = null
        state.success = null
      })
      .addCase(getSupportedLoyaltyPrograms.fulfilled, (state, { payload }) => {
        state.loading = false
        state.success = payload
        state.error = null
      })
      .addCase(getSupportedLoyaltyPrograms.rejected, (state, { payload }) => {
        state.loading = false
        state.error = payload as GetSupportedLoyaltyProgramsErrorResponse
        state.success = null
      })
  }
})

export const { actions: getSupportedLoyaltyProgramsActions, reducer: getSupportedLoyaltyProgramsReducer } =
  getSupportedLoyaltyProgramsSlice
export default getSupportedLoyaltyProgramsSlice.reducer
